'use client';

import React from 'react';

/**
 * Card mode types for different visual styles
 */
export type CardMode = 'primary' | 'secondary' | 'danger';

/**
 * Card component properties
 */
export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  mode?: CardMode;
  glow?: boolean;
}

/**
 * Card component with neon border styling
 * @param {CardProps} props - Card properties
 * @returns {JSX.Element} Styled card container with neon glow
 */
export const Card: React.FC<CardProps> = ({
  className = '',
  mode = 'primary',
  glow = true,
  children,
  ...props
}) => {
  const baseClasses = 'bg-gray-900 border-2 rounded-lg p-6 transition-all duration-300';

  const modeClasses = {
    primary: 'border-cyan-400',
    secondary: 'border-fuchsia-400',
    danger: 'border-danger',
  } as const;

  const glowClasses = {
    primary: 'neon-glow-primary',
    secondary: 'neon-glow-secondary',
    danger: 'neon-glow-danger',
  } as const;

  const classes = `${baseClasses} ${modeClasses[mode]} ${glow ? glowClasses[mode] : ''} ${className}`.trim();

  return <div x-component-name="Card" className={classes} {...props}>{children}</div>;
};